const vacansy = {
    state: () => ({
        vacansy : [
            {
                jobName : 'Старший продавец',
                lookingForTitle : 'Мы ищем тех, кто:',
                lookingFor : [
                    'Активен! Активен и еще раз активен;',
                    'Действительно хочет работать и постоянно развиваться;',
                    'Понимает, что уровень продаж зависит от него, а не от настроения, умственного развития и других характеристик клиента;',
                    'Коммуникабелен и клиентоориентирован;',
                    'Предпочитает тратить энергию на обучение, а не на оправдание и споры;',
                    'Хочет заработок бизнес-класса, а не на мороженое в парке!'
                ],
                requirementsTitle : 'Требования',
                requirements : [
                    'Опыт работы в любом сегменте e-commerce;',
                    'Вежливость и терпеливость в общении с клиентами;',
                    'Готовность к работе в ненормированном графике.'
                ],
                termsTitle : 'Условия',
                terms : [
                    'Продажа классных хайповых товаров;',
                    'Работа со входящим трафиком как по телефону так и в магазине;',
                    'Специальный прайс на все товары для себя и самых близких;',
                    'Зарплата без лимита. Верхний предел дохода ограничивается только Вашей ленью!;',
                    'Официальное трудоустройство по ТК РФ.'
                ]
            },
            {
                jobName : 'Менеджер по продажам',
                lookingForTitle : 'Мы ищем тех, кто:',
                lookingFor : [
                    'Активен! Активен и еще раз активен;',
                    'Действительно хочет работать и постоянно развиваться;',
                    'Понимает, что уровень продаж зависит от него, а не от настроения, умственного развития и других характеристик клиента;',
                    'Коммуникабелен и клиентоориентирован;',
                    'Предпочитает тратить энергию на обучение, а не на оправдание и споры;',
                    'Хочет заработок бизнес-класса, а не на мороженое в парке!'
                ],
                requirementsTitle : 'Требования',
                requirements : [
                    'Опыт работы в любом сегменте e-commerce;',
                    'Вежливость и терпеливость в общении с клиентами;',
                    'Готовность к работе в ненормированном графике.'
                ],
                termsTitle : 'Условия',
                terms : [
                    'Продажа классных хайповых товаров;',
                    'Работа со входящим трафиком как по телефону так и в магазине;',
                    'Специальный прайс на все товары для себя и самых близких;',
                    'Зарплата без лимита. Верхний предел дохода ограничивается только Вашей ленью!;',
                    'Официальное трудоустройство по ТК РФ.'
                ]
            },
            {
                jobName : 'Директор магазина',
                lookingForTitle : 'Мы ищем тех, кто:',
                lookingFor : [
                    'Активен! Активен и еще раз активен;',
                    'Действительно хочет работать и постоянно развиваться;',
                    'Понимает, что уровень продаж зависит от него, а не от настроения, умственного развития и других характеристик клиента;',
                    'Коммуникабелен и клиентоориентирован;',
                    'Предпочитает тратить энергию на обучение, а не на оправдание и споры;',
                    'Хочет заработок бизнес-класса, а не на мороженое в парке!'
                ],
                requirementsTitle : 'Требования',
                requirements : [
                    'Опыт работы в любом сегменте e-commerce;',
                    'Вежливость и терпеливость в общении с клиентами;',
                    'Готовность к работе в ненормированном графике.'
                ],
                termsTitle : 'Условия',
                terms : [
                    'Продажа классных хайповых товаров;',
                    'Работа со входящим трафиком как по телефону так и в магазине;',
                    'Специальный прайс на все товары для себя и самых близких;',
                    'Зарплата без лимита. Верхний предел дохода ограничивается только Вашей ленью!;',
                    'Официальное трудоустройство по ТК РФ.'
                ]
            },
            {
                jobName : 'Кладовщик',
                lookingForTitle : 'Мы ищем тех, кто:',
                lookingFor : [
                    'Активен! Активен и еще раз активен;',
                    'Действительно хочет работать и постоянно развиваться;',
                    'Понимает, что уровень продаж зависит от него, а не от настроения, умственного развития и других характеристик клиента;',
                    'Коммуникабелен и клиентоориентирован;',
                    'Предпочитает тратить энергию на обучение, а не на оправдание и споры;',
                    'Хочет заработок бизнес-класса, а не на мороженое в парке!'
                ],
                requirementsTitle : 'Требования',
                requirements : [
                    'Опыт работы в любом сегменте e-commerce;',
                    'Вежливость и терпеливость в общении с клиентами;',
                    'Готовность к работе в ненормированном графике.'
                ],
                termsTitle : 'Условия',
                terms : [
                    'Продажа классных хайповых товаров;',
                    'Работа со входящим трафиком как по телефону так и в магазине;',
                    'Специальный прайс на все товары для себя и самых близких;',
                    'Зарплата без лимита. Верхний предел дохода ограничивается только Вашей ленью!;',
                    'Официальное трудоустройство по ТК РФ.'
                ]
            },
        ]
    }),
    getters : {
        getVacansy(state){
            return state.vacansy
        }

    },
    mutations : {

    },
    actions : {

    }
}

export default vacansy